import React from "react";
import "./articles.css"

const AboutAssociation = () => {

    return (
        <div className="main">
            <div className="art-container">
                <div className="about-header">
                    <h1>About the Association</h1>
                </div>
                <div className="about-content-container">
                    <div className="overview-content">
                        <div className="about-sub-heading">
                            <h2>Welcome to the Girijananda Chowdhury University Alumni Association (GCUAA)—</h2>
                        </div>
                        <div className="article-text">
                            <p>a vibrant community of graduates who share a passion for the alma mater and a commitment to 
                                supporting its mission and values. The Alumni Association is dedicated to supporting and 
                                engaging our alumni network, offering a wide range of services, events, and resources to keep 
                                them connected with the University and their fellow graduates.
                            </p>
                            <p>
                                At Girijananda Chowdhury University (GCU), we believe in the value of connections that last a 
                                lifetime. The Girijananda Chowdhury University has evolved in 2022 out of the initiative of the 
                                Girijananda Chowdhury Institute of Management and Technology (GIMT) [established in 2006] 
                                and the Girijananda Chowdhury Institute of Pharmaceutical Sciences (GIPS) [established in 
                                2007] to impart professional higher education in a spirit of philanthropy and social 
                                commitment. The Girijananda Chowdhury Institute of Management and Technology Guwahati 
                                Alumni Association came into existence in 2013 bearing registration number 
                                RS/KAM(M)/263/I/421 of 2014-15. In addition, the Girijananda Chowdhury Institute of 
                                Pharmaceutical Science Guwahati Alumni Association was established in 2014 with registration 
                                no. RS/KAM(M)263/W/01 of 2021-22. The GCU amalgamated both the Alumni Associations 
                                naming it ‘Girijananda Chowdhury University Alumni Association’ (GCUAA) and registered them 
                                under the Assam Society Registration Act XXI of 1860 with registration no. 
                                RS/KAM(M)263/W/01 of 2021-22. 
                            </p>
                        </div>
                    </div>

                </div>
                <div className="goal-content-container">
                    <div className="goal-content">
                        <div className="goal-sub-heading">
                            <h2>Our Goal</h2>
                        </div>
                        <div className="article-text">
                            <p>
                                A University's alumni are the reflection of its past, a representation of its present, and a link to 
                                its future. The primary goal of our Alumni Association is to foster a lifelong relationship between 
                                alumni and their alma mater, facilitating a sense of community and supporting both the 
                                institution and its graduates. GCUAA provides logistics help to students and alumni, organizes 
                                in-house lectures and workshops for students, research scholars, and staff, and organizes 
                                outreach activities in schools and colleges. Donations and financial gifts from alumni make a 
                                direct impact on the future of the University, supporting scholarships, research, and programs 
                                that benefit the next generation of students. In the past, it has collected approximately Rs. 30 
                                lakhs through membership drives and donations. The GCU alums are spread across the globe 
                                and are occupied internationally. The GCUAA has an Alumni Office on the 3rd Floor of the 
                                Admin Building at GCU. The GCUAA has recently contributed Rs. 2 lacs from the association 
                                fund for the University’s development purposes.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="connect-container">
                    <div className="connect-content">
                        <div className="goal-sub-heading">
                            <h2>Engage, Connect and Unite</h2>
                        </div>
                        <div className="article-text">
                            <p><span>The GCUAA is the ideal vehicle for nurturing a strong, reciprocal relationship between the GCU 
                                and its alumni, enabling all of us, wherever we are, to Engage, Connect, and Unite. An engaged 
                                alumni community is a vibrant community that actively reaches out, participates fully, and 
                                welcomes and shares new ideas and fresh thinking. There are several ways you can engage with 
                                the GCUAA: 
                            </span></p>
                        </div>
                        <div className="engage-box">
                            <p>Become a member of the Alumni Association or, serve on the Alumni Association as an 
                            elected member of the Executive Committee. </p>
                        </div>
                        <div className="connect-box">
                            <p>Have your say on the Alumni Association’s social media platforms, including Twitter, 
                            Facebook, and website. </p>
                        </div>
                        <div className="unite-box">
                            <p>Attend alumni events, including public lectures, awards ceremonies, and Alumni 
                            Association meetings. </p>
                        </div>
                    </div>
                </div>
                <div className="goal-content-container">
                    <div className="goal-content">
                        <div className="goal-sub-heading">
                            <h2>Perks</h2>
                        </div>
                        <div className="article-text">
                            <p>
                                Being a GCU alumnus gives you access to an encyclopedia of knowledge by reaching out to 
                                other alumni and building networks. Share experiences, gain different perspectives on common 
                                problems, and seek solutions that can benefit the continent. 
                            </p>
                            <ul>
                                <li>Lifetime access to the GCU library is available to alumni in good standing, along with 
                                    online resources such as e-magazines, etc.
                                </li> 
                                <li>Receive the regular newsletter to see what fellow alumni are getting up to and the 
                                    heights they are reaching. 
                                </li>
                                <li>Get social.</li>
                            </ul>
                            <p>As alumni, let us stand together in advancing the goal of GCU to be the leading University in 
                                our country. 
                            </p>
                            <ul>
                                <li>Be a guest lecturer and share your experience.</li>
                                <li>Attend courses and lectures to continue your path of lifelong learning.</li>
                                <li>Fund bursaries or help raise funds.  </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="thank-you-container">
                    <div className="thank-you-content">
                        <h3>༺𝓉𝒽𝒶𝓃𝓀 𝓎ℴ𝓊༻</h3>
                        <p> for being a part of the Girijananda Chowdhury University Alumni Association. 
                        Together, we continue to grow, succeed, and make an impact in the world. </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutAssociation;
